import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PublicLayout, PageContainer } from "@/components/PublicLayout";
import { CommonNumberCard } from "@/components/CommonNumberCard";
import { SeoContent } from "@/components/SeoContent";
import { LoadingState, ErrorState } from "@/components/States";
import { useSeo } from "@/lib/useSeo";
import { CalendarBlank } from "@phosphor-icons/react";

export default function CommonNumber() {
  useSeo({
    title: "Guwahati Morning Teer Common Number Today | Direct House Ending",
    description: "Today's Guwahati Morning Teer Common Number - Direct Number, House and Ending. Updated daily. For informational purposes only.",
    path: "/common-number",
  });
  const dateQ = useQuery({ queryKey: ["date"], queryFn: async () => (await api.get("/date/today")).data });
  const q = useQuery({ queryKey: ["common-number"], queryFn: async () => (await api.get("/numbers")).data });

  const activeDate = q.data?.date || dateQ.data?.date;

  return (
    <PublicLayout>
      <PageContainer className="py-10">
        <div className="inline-flex items-center gap-2 text-brand mb-6">
          <CalendarBlank className="w-5 h-5" weight="duotone" />
          <span className="text-xs font-bold uppercase tracking-widest">Common Number</span>
        </div>

        {q.isLoading ? (
          <LoadingState />
        ) : q.isError ? (
          <ErrorState onRetry={q.refetch} />
        ) : (
          <CommonNumberCard date={activeDate} rows={q.data?.rows || []} testId="common-number-card" />
        )}

        <SeoContent page="common" />
      </PageContainer>
    </PublicLayout>
  );
}
